import React from 'react';

import FirstRegIcon from '../components/reports/params/attribution/icons/FirstRegIcon';
import LastRegIcon from '../components/reports/params/attribution/icons/LastRegIcon';
import TypeIcon from '../components/reports/params/attribution/icons/TypeIcon';


export const checkedDetailsList = [
  { name: 'по дням', value: 'd' },
  { name: 'по неделям', value: 'w' },
  { name: 'по дням недели', value: 'd-w' },
  { name: 'по месяцам', value: 'm' },
  { name: 'по кварталам', value: 'q' },
  { name: 'по годам', value: 'y' },
  { name: '1 минута', value: '1m' },
  { name: '5 минут', value: '5m' },
  { name: '15 минут', value: '15m' },
];

export const chartDetails = [
  { name: 'по дням', value: 'd' },
  { name: 'по неделям', value: 'w' },
  { name: 'по дням недели', value: 'd-w' },
  { name: 'по месяцам', value: 'm' },
  { name: 'по кварталам', value: 'q' },
  { name: 'по годам', value: 'y' },
];
export const dashboardChartDetails = [
  { name: 'по дням', value: 'd' },
  { name: 'по неделям', value: 'w' },
  { name: 'по дням недели', value: 'd-w' },
  { name: 'по месяцам', value: 'm' },
  { name: 'по кварталам', value: 'q' },
  { name: 'по годам', value: 'y' },
  { name: 'По умолчанию', value: 'blocks' },
];

export const webinarDetails = [
  { name: '1 минута', value: '1m' },
  { name: '5 минут', value: '5m' },
  { name: '15 минут', value: '15m' },
];

export const cogDetails = [
  { name: 'по дням', value: 'd' },
  { name: 'по неделям', value: 'w' },
  { name: 'по месяцам', value: 'm' },
  { name: 'по кварталам', value: 'q' },
  { name: 'по годам', value: 'y' },
];
